import { Component, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-modal-cart',
  templateUrl: './modal-cart.component.html',
})
export class ModalCartComponent {

  @ViewChild('modalCart') modalCart: TemplateRef<ModalCartComponent> | undefined;


  modal = true;

  constructor() {}

  abrirModal(){
    this.modal!= this.modal;
  }
}
